
<section>
  <!-- Progress Bar(s) -->
  <div
    class="bg-grey-background-subdued sm:bg-white p-16 sm:box-shadow-sm transition-text"
    :class="!showTransitionText && 'collapsed'"
  >
    <p v-if="progressBarTitle" class="text-overline text-grey-header">{{ progressBarLabel }}</p>
    <slot name="progressBar" :currentStep="currentStep" :maxSteps="steps.length + 1" />
    <transition :name="back ? 'back' : 'text'">
      <p v-if="showTransitionText" class="mt-8 text-caption">{{ step.transitionText || 'Great' }}</p>
    </transition>
  </div>
  <div class="fixed-height flex justify-center">
    <transition :name="back ? 'back' : 'slide'">
      <div v-show="showCard" class="sm:mt-16 fixed-height" :class="cardWidthClass">
        <!-- Breadcrumb + Header -->
        <div class="w-full pl-16 sm:pl-0">
          <Breadcrumb
            v-if="!isFirstStep"
            :aria-label="`Back to ${breadcrumbHeader}`"
            class="mb-16"
            :header="breadcrumbHeader"
            :isButton="true"
            @click="previousStep"
          />
          <h1 class="text-h2 mr-12">{{ step.title }}</h1>
          <p v-if="step.required" class="text-small text-grey-text-subdued mt-4">Required</p>
        </div>
        <!-- Stepper Content -->
        <Card class="form-stepper-card sm:mt-16 box-shadow-none sm:box-shadow-sm sm:p-24">
          <component
            :is="step.component"
            v-if="step.component"
            ref="stepComponent"
            class="step-component"
            :class="step.xlCard && 'xl'"
          />
          <div v-else>{{ step.title }} content</div>
          <div class="sm:mt-24" :class="stickyButtonWidthClass">
            <StickyButton :value="buttonValue" :loading="loading" @click="handleAction" />
          </div>
        </Card>
      </div>
    </transition>
  </div>
</section>
